const PAGE_TYPE = Object.freeze({
  VENUE_DETAILS_PAGE: 'venueDetailsPage',
});

const isVenueDetailsPage = (pageType) =>
  pageType === PAGE_TYPE.VENUE_DETAILS_PAGE;

export { PAGE_TYPE, isVenueDetailsPage };
